import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    zoonosis: [],
  },

  getters: {
    getZoonosis: (state) => state.zoonosis,
  },

  mutations: {
    SET_ZOONOSIS(state, zoonosis) {
      state.zoonosis = zoonosis;
    },
  },

  actions: {
    async fetchZoonosis({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/zoonosis`)
        .then((response) => {
          commit('SET_ZOONOSIS', response.data.data);
        });
    },

    async saveZoonosis(context, listaZoonosis) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;

      await Promise.all(
        listaZoonosis.map(async (zoonosis) => {
          await axios
            .post(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/zoonosis`, zoonosis);
        }),
      );
    },

    async updateZoonosis(_, zoonosis) {
      await axios
        .put(`PoliciaCuadrantes/C3/historiaClinica/${zoonosis.fk_idHistoriaClinica}/zoonosis/${zoonosis.fk_idZoonosis}`, zoonosis);
    },
  },
};
